import { CIcon } from '~/icons/types'

export const ciMassCateringEquipment: CIcon = {
  width: '24',
  height: '24',
  paths: [
    { d: 'M5.086 5.625h2.5a.5.5 0 0 0 0-1h-2.5a.5.5 0 1 0 0 1Z' },
    {
      d:
        'M21.414 9.625h-2.7v-1.5h1.375a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H2.586a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1.375v10.25h-.125a1.752 1.752 0 0 0-1.75 1.75v1.25a.5.5 0 0 0 .5.5h17.5a.5.5 0 0 0 .5-.5v-1.25a1.752 1.752 0 0 0-1.75-1.75h-.125v-7.75h2.7a.5.5 0 0 0 0-1h.003Zm-3.7 0h-3.73l.272-1.5h3.458v1.5Zm-7.833.937-.446-2.437h3.8l-.443 2.437h-2.91ZM3.086 3.125h16.5v4h-16.5v-4Zm16.5 17v.75h-16.5v-.75a.751.751 0 0 1 .75-.75h15a.751.751 0 0 1 .75.75Zm-10.168-4.5h3.914l-.229 2.75H9.647l-.229-2.75Zm8.293 2.75h-3.6l.121-1.461h1.211a.5.5 0 0 0 0-1h-1.132l.062-.747a.5.5 0 0 0-.498-.542h-5a.5.5 0 0 0-.498.542l.267 3.208H4.961V8.125h3.457l.551 3.027a.5.5 0 0 0 .492.41h1.375v1.063a.5.5 0 1 0 1 0v-1.063h1.375a.5.5 0 0 0 .492-.41l.1-.527h3.912l-.004 7.75Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'mass-catering-equipment',
  type: 'thin'
}
